import { push } from 'connected-react-router';

import { createProject, updateProject } from 'common/api/v1/projects';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import fetchProject from '../../project/actions/fetchProject';
import filterProjects from '../../projects/actions/filterProjects';
import {
    SAVE_PROJECT,
    SAVE_PROJECT_SUCCESS,
    SAVE_PROJECT_FAILURE,
} from '../actionTypes';
import { createProjectModalActions } from '../reducer';

import closeModal from './closeModal';

export default (filterData, values) => (dispatch) => {
    dispatch(createProjectModalActions[SAVE_PROJECT]());

    let newValues = {
        address: values.address,
        city: values.city,
        country: values.country,
        latitude: values.latitude,
        longitude: values.longitude,
        name: values.name,
        state: values.state,
    };

    if (values.contact === 'new_contact')
        newValues.contact_name = values.contact_name;
    else newValues.contact = values.contact;

    const save = values.id
        ? () => updateProject(newValues, values.id)
        : () => createProject(newValues);

    save()
        .then((response) => {
            dispatch(
                createProjectModalActions[SAVE_PROJECT_SUCCESS](response.data),
            );
            dispatch(closeModal());
            const {
                contact: { id: contactId },
                id: projectId,
            } = response.data;
            if (filterData) dispatch(filterProjects(filterData));
            if (values?.id) dispatch(fetchProject(values.id));
            showToast();
            dispatch(push(`/contacts/${contactId}/${projectId}`));
        })
        .catch((error) => {
            dispatch(
                createProjectModalActions[SAVE_PROJECT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
